import {Component} from '@angular/core';
import {PromotionWizardService} from '../../services/promotion/promotion-wizard.service';
import {PromotionMessageService} from '../../services/promotion/promotion-message.service';
import {PromotionMessageLayoutService} from '../../services/promotion/promotion-message-layout.service';

@Component({
  selector: 'kv-promo-test',
  template: ``
})
export class PromoTestComponent {
  constructor(
    svcWizard: PromotionWizardService,
    svcMessage: PromotionMessageService,
    svcMessageLayout: PromotionMessageLayoutService
  ) {

    svcWizard.list(null, null, [
      {
        key: 'type',
        value: 'message'
      }
    ]).subscribe(res => {
      console.log(res)
    });

    svcWizard.getConfig(1).subscribe(res => {
      console.log('config', JSON.parse(res))
    });

    svcMessage.list().subscribe();

    svcMessageLayout.list(null, null, [{key: 'message_id', value: '1'}]).subscribe((res) => {
      console.log('message layout del message 1: ', res );
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/promo-test.component.ts